import React, {FunctionComponent} from "react"
import {DroneComponent} from "@murphy-frontend/common/api/DroneEvents/types"

interface TitleBlockProps {
	eventFlowBlock: DroneComponent
}

const TitleBlock: FunctionComponent<TitleBlockProps> = ({eventFlowBlock}) => {
	return <div className='event-block-title'>{eventFlowBlock.Title}</div>
}

export default TitleBlock
